import { EPublishOfferStatus, IPublishInfoState } from './types';

export const defaultState: IPublishInfoState = {
  status: EPublishOfferStatus.initial,
  errorCode: null,
  errorMessage: null,
  errors: null,
  type: null,
  message: null,
  servicesToDeactivate: null,
  checkFailed: false,
  isSubagentNotEnoughMoney: false,
};
